// Mock data for AGK Electric Inc.

export const businessInfo = {
  name: "AGK Electric Inc.",
  tagline: "Professional Electrical Services You Can Trust",
  phone: "416-271-7063",
  email: "agkelectricinc@gmail.com",
  serviceArea: "Greater Toronto Area (GTA)",
  experience: "10+ years",
  certification: "IBEW Certified Electrician",
  availability: "24/7 Emergency Services",
  social: {
    facebook: "https://www.facebook.com/share/17wGcnZPKd/",
    instagram: "https://www.instagram.com/agkelectricinc",
    google: "" // Add your Google Business page URL here when ready
  }
};

export const services = [
  {
    id: 1,
    title: "Backup Power Solutions",
    description: "Keep your home powered during outages with professional generator installation and maintenance.",
    icon: "battery-charging"
  },
  {
    id: 2,
    title: "EV Charger Installation",
    description: "Professional electric vehicle charging station installation for your home or business.",
    icon: "car"
  },
  {
    id: 3,
    title: "Service Upgrades",
    description: "Upgrade your electrical panel and service to meet modern power demands safely.",
    icon: "zap"
  },
  {
    id: 4,
    title: "Pot Light Installation",
    description: "Modern, energy-efficient pot light installation to brighten your space beautifully.",
    icon: "lightbulb"
  },
  {
    id: 5,
    title: "Troubleshooting & Repairs",
    description: "Expert diagnosis and repair of electrical issues to keep your home safe and functional.",
    icon: "wrench"
  },
  {
    id: 6,
    title: "Renovations & More",
    description: "Complete electrical services for your renovation projects and custom installations.",
    icon: "home"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Customer Name",
    location: "Toronto, ON",
    rating: 5,
    text: "Your customer testimonial will appear here. Reviews from Facebook, Instagram, and Google will be featured.",
    platform: "google"
  },
  {
    id: 2,
    name: "Customer Name",
    location: "Mississauga, ON",
    rating: 5,
    text: "Your customer testimonial will appear here. Reviews from Facebook, Instagram, and Google will be featured.",
    platform: "facebook"
  },
  {
    id: 3,
    name: "Customer Name",
    location: "Brampton, ON",
    rating: 5,
    text: "Your customer testimonial will appear here. Reviews from Facebook, Instagram, and Google will be featured.",
    platform: "instagram"
  }
];

export const reviewPlatforms = [
  {
    name: "Google",
    icon: "star",
    url: businessInfo.social.google || "#", // Will be updated when Google Business page is created
    color: "bg-blue-600",
    hoverColor: "hover:bg-blue-700",
    description: "Leave us a Google review"
  },
  {
    name: "Facebook",
    icon: "facebook",
    url: businessInfo.social.facebook,
    color: "bg-blue-600",
    hoverColor: "hover:bg-blue-700",
    description: "Review us on Facebook"
  },
  {
    name: "Instagram",
    icon: "instagram",
    url: businessInfo.social.instagram,
    color: "bg-pink-600",
    hoverColor: "hover:bg-pink-700",
    description: "Follow & review on Instagram"
  }
];
